export enum FilterPopoverTabs {
  Whitelabels,
  Clients,
  Advertisers,
  Campaigns,
}
